import styled from 'styled-components';
import { Skeleton } from 'antd';

const SkeletonBreadcrumb = styled(Skeleton.Input)`
    height: 10px !important;
`;

export default SkeletonBreadcrumb;
